import { PromotionCountdown } from "@/features/subscription-request/components/PromotionCountdown";
import type { UpsellPlanPricing } from "@/features/subscription-request/types/subscriptionRequest.types";
import { applyDiscountPercent, formatEurosCents } from "@/shared/utils/price.utils";
import { COLOR_CHARCOAL, COLOR_MUTED, COLOR_PURPLE } from "../constants/upsellPage.constants";

type PlanPriceBlockProps = { pricing: UpsellPlanPricing | undefined };

const PlanPriceBlock = ({ pricing }: PlanPriceBlockProps) => {
  if (!pricing) return null;

  if (pricing.hide_price || pricing.total_monthly_cents === null) {
    return (
      <div className="mb-6">
        <p className="font-medium" style={{ color: COLOR_CHARCOAL, fontSize: "1.5rem" }}>
          Devis sur mesure
        </p>
        <p className="text-xs" style={{ color: COLOR_MUTED }}>
          Contactez-nous pour une offre adaptée à votre CSE
        </p>
      </div>
    );
  }

  const baseTotal = pricing.total_monthly_cents;
  const discount = pricing.active_discount;
  const discountedTotal = discount ? applyDiscountPercent(baseTotal, discount.percent) : null;

  return (
    <div className="mb-6">
      {discount && discountedTotal !== null
        ? (
          <div className="flex items-baseline gap-2">
            <span
              className="text-sm line-through"
              style={{ color: COLOR_MUTED }}
              aria-label={`Prix initial ${formatEurosCents(baseTotal)} par mois`}
            >
              {formatEurosCents(baseTotal)}
            </span>
            <span
              className="font-medium"
              style={{ color: COLOR_CHARCOAL, fontSize: "1.75rem", lineHeight: 1.1 }}
            >
              {formatEurosCents(discountedTotal)}
            </span>
            <span className="text-sm" style={{ color: COLOR_MUTED }}>/ mois</span>
          </div>
        )
        : (
          <div className="flex items-baseline gap-2">
            <span
              className="font-medium"
              style={{ color: COLOR_CHARCOAL, fontSize: "1.75rem", lineHeight: 1.1 }}
            >
              {formatEurosCents(baseTotal)}
            </span>
            <span className="text-sm" style={{ color: COLOR_MUTED }}>/ mois</span>
          </div>
        )}

      <p className="mt-1 text-xs" style={{ color: COLOR_MUTED }}>
        pour vos
        {" "}
        {pricing.employee_count}
        {" "}
        employé
        {pricing.employee_count > 1 ? "s" : ""}
      </p>

      {discount && (
        <div className="mt-2 flex flex-col items-start gap-1">
          <span
            className="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-bold text-white"
            style={{ backgroundColor: COLOR_PURPLE }}
          >
            -
            {discount.percent}
            % de remise
          </span>
          <PromotionCountdown endsAt={discount.ends_at} />
        </div>
      )}
    </div>
  );
};

export default PlanPriceBlock;
